import React, { useEffect, useRef } from 'react';
import astronautRocket from '../../assets/images/cartoon_rocket.webp';

export default function FloatingRocketAstronaut() {
  const imgRef = useRef(null);

  // Native CSS rendering (zero main-thread blocking)

  return (
    <div className="hidden lg:block relative w-full z-30 pointer-events-none select-none">
      {/* Embedded Animation Styles */}
      <style>{`
        @keyframes rocketFloatAnim {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-14px) rotate(3deg);
          }
        }
        .animate-rocket-float {
          animation: rocketFloatAnim 3.8s ease-in-out infinite;
        }

        @keyframes flamePulseAnim {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.85; transform: scale(1.1); }
        }
        .animate-flame-pulse {
          animation: flamePulseAnim 2s ease-in-out infinite;
        }
      `}</style>

      {/* Floating Rocket Astronaut Container (Outer Right Margin, Between both sections) */}
      <div className="absolute right-4 sm:right-8 lg:right-12 xl:right-16 2xl:right-24 -top-0 lg:-top-10 w-24 sm:w-28 md:w-32 lg:w-36 xl:w-44">
        {/* Ambient Flame & Cyber Glow behind rocket */}
        <div className="absolute right-2 bottom-1 w-16 sm:w-20 lg:w-24 h-16 sm:h-20 lg:h-24 bg-gradient-to-tr from-amber-500/30 via-rose-500/25 to-cyber-cyan/20 rounded-full blur-[25px] pointer-events-none animate-flame-pulse" />

        {/* Animated Rocket Astronaut Image */}
        <div className="animate-rocket-float transform hover:scale-105 transition-transform duration-500">
          <img
            ref={imgRef}
            src={astronautRocket}
            alt="Astronaut Riding Rocket"
            className="w-full h-auto object-contain filter drop-shadow-[0_8px_16px_rgba(0,0,0,0.7)] drop-shadow-[0_0_15px_rgba(255,80,0,0.3)]"
            loading="eager"
            decoding="async"
            style={{ mixBlendMode: 'screen' }}
          />
        </div>
      </div>
    </div>
  );
}
